import React from 'react';

import { UxContext } from '@client/context/UxContext';
import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import lediumApi from '@client/utils/lediumApi';
import { Search } from '@mui/icons-material';
import { Button } from '@mui/material';

const DmxChannelSearchNextFreeButton = () => {
    const { handleSnackbar } = React.useContext(UxContext)!;
    const {
        pageState: { formData },
        pageActions
    } = usePageStore();

    function searchNextFreeChannel() {
        lediumApi.get<number | null>(`lightChannels/getNextFreeDmx/${formData.resolution}/${formData.id ? formData.id : ''}`).then((data) => {
            if (data === null) {
                handleSnackbar({
                    message: i18n('next_free_channel_can_not_allocate', formData.resolution as string) as string,
                    severity: 'error'
                });
            } else if (data) {
                handleSnackbar({
                    message: i18n('next_free_channel_found', formData.resolution as string) as string
                });
                pageActions.formData.updateFormItem({ channel: data });
            }
        });
    }

    return (
        <Button sx={{ marginTop: '8px' }} variant="contained" onClick={searchNextFreeChannel} startIcon={<Search />}>
            {i18n('search_next_free_channel')}
        </Button>
    );
};

export default DmxChannelSearchNextFreeButton;
